import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import FoxTrader from "./../../../Images/foxtrader.png";
import "./QuantmanDownload.css";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';

function QuantmanDownload() {
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const { isFetching, isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

            console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://www.quantman.in',
                '_blank' // <- This is what makes it open in a new window.
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
  return (
    <>
      <section className="fox-download">
        <Container>
          <Row>
            <Col md={5}>
              <div className="fox-download-img">
                <img className="img-fluid" src={FoxTrader} alt="FoxTrader" />
              </div>
            </Col>
            <Col md={7}>
              <div>
                <h3> Quantman</h3>
                <p>
                Open your account now and get 50 back tests free. Additionally you will get live deployment of strategy for 6 days.
                </p>
                          </div>
                          <div>
                              <button type="button" onClick={() => clickToggleLoginPopup(true)}  className="Login-Button-fox w-50 startnow_btn end-0">
                                   Get Started
                              </button>
                          </div>  
            </Col>
                  </Row>
                  <LoginPopup show={show} ref={childRef} />
              </Container>

      </section>
    </>
  );
}
export default QuantmanDownload;
